import React from 'react';

import './CardNE.scss';

export interface CardNEProps {
  title?: string;
  description?: string;
  className?: string;
  flexDirection?: 'row' | 'column';
}

const CardNE = ({
  title,
  description,
  className,
  children,
  flexDirection = 'column'
}: React.PropsWithChildren<CardNEProps>) => {
  return (
    <div className={`card-container-ne ${flexDirection === 'row' ? 'flex-row' : 'flex-column'} ${className}`}>
      {title && (
        <div className="card-header">
          <div className="title-container">
            <div className="title">{title}</div>
          </div>
          {description && <div className="description">{description}</div>}
        </div>
      )}
      {children}
    </div>
  );
};

export default CardNE;
